import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import brandInfo from "src/environments/brand.json";
import { Location } from '@angular/common';
import { AppConfigService } from "src/app/appconfig/appconfig.service";
@Injectable({
  providedIn: "root",
})
export class PagesService {
  pages = {
    landingPage: `${brandInfo.homePage}`,
    ratingPage: brandInfo.brand === 'REV' ? "plans-pricing" : "my-vsp-pricing",
    cartPage: "cart",
    checkoutPage: "checkout",
  };

  ratingPages = ["/my-vsp-pricing-electric", 
                  "/my-vsp-pricing",
                  "/electric-vsp-pricing",
                  "/vsp-pricing",
                  "/tire-wheel-pricing",
                  "/my-asp-pricing",
                  "/my-ppm-pricing",
                  "/my-pmp-pricing", 
                  "/plans-pricing",
                  "/electric-plans-pricing",
                  "/ppm-pricing",
                  "/ppm-ev-pricing",
                  "/my-lamborghini-rates",
                  "/my-bmw-rates",
                  "/my-mini-rates"]

  // Dynamically fetched list of rate landing pages from Prismic via AppConfigService
  prismicRatingPages: string[] = [];

  constructor(private router: Router, private location: Location, private appConfig: AppConfigService ) {
    // Subscribe to dynamic settings coming from Prismic
    this.appConfig.getSettings().subscribe((settings: any) => {
      if (settings && Array.isArray(settings.rates_landing_pages)) {
        this.prismicRatingPages = settings.rates_landing_pages;
      }
    });
  }

  getRatingPages() {
    return this.ratingPages;
  }

  getLandingPage() {
    // This is a fix for an anomaly that redirects erroneously to 'help' instead of 'home' for nissan - D2C-2513
    if (this.pages.landingPage === 'help') {
      return '';
    } else {
      if (sessionStorage.getItem('appFlowState') && sessionStorage.getItem('appFlowState').includes('serviceDrive')) {
        return 'service-drive';
      } else {
        return brandInfo.homePage; 
      }
    } 
  }

  redirectTo(uri: string, queryParams = null) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    if (queryParams) {
      if (brandInfo.hideLandingPage && (uri.includes(brandInfo.homePage) || uri.includes(brandInfo.homePageElectric))) {
        this.router.navigate([uri], { queryParams: { oid: queryParams }, skipLocationChange: true });
        this.location.replaceState('/');
      } else {
        this.router.navigate([uri], { queryParams: { oid: queryParams }, skipLocationChange: false });
      }

    } else {
      if (brandInfo.hideLandingPage && (uri.includes(brandInfo.homePage) || uri.includes(brandInfo.homePageElectric))) {
        this.router.navigate([uri], { skipLocationChange: true })
        this.location.replaceState('/');
      } else {
        this.router.navigate([uri], { skipLocationChange: false })
      }
    }

  }

  setLandingPage(landingPage) {
    this.pages.landingPage = landingPage;
    return this.pages.landingPage;
  }

  /**
   * Single route segment for rates landing: no leading `/`, `?query`, or `#hash`.
   * Prevents `router.navigate(['my-bmw-rates?plan=x'])` turning `?` into `%3F` in the path.
   */
  private normalizeRatingPagePath(raw: string | null | undefined): string {
    if (raw == null || typeof raw !== 'string') {
      return '';
    }
    let s = raw.trim().replace(/^\//, '');
    s = s.split('?')[0] ?? '';
    s = s.split('#')[0] ?? '';
    return s.trim();
  }

  getRatingPage(): string {
    const path = this.normalizeRatingPagePath(this.pages.ratingPage);
    if (path) {
      return path;
    }
    return brandInfo.brand === 'REV' ? "plans-pricing" : "my-vsp-pricing";
  }

  setRatingPage(ratingPage: string | undefined | null) {
    const next = this.normalizeRatingPagePath(ratingPage ?? '');
    this.pages.ratingPage = next || this.normalizeRatingPagePath(this.pages.ratingPage);
    window.sessionStorage.setItem("pagesFlow", JSON.stringify(this.pages));
    return this.pages.ratingPage;
  }

  isRatingPage(url: string) {
    const pathOnly = url.split('?')[0].split('#')[0];
    if (this.ratingPages.includes(pathOnly)) {
      return true;
    }
    if (this.prismicRatingPages.includes(pathOnly) || this.prismicRatingPages.includes(url)) {
      return true;
    }
    return false;
  }
}
